import React from 'react';
import styled from 'styled-components';
import { useI18n } from '@oneaudi/i18n-context';
import { TextButton, Text, Headline } from '@oneaudi/unified-web-components';
import { SYS_SPACE_FIXED_300, SYS_SPACE_FIXED_100, SYS_SPACE_FIXED_50, } from '@oneaudi/unified-web-common';
import { DangerousElement } from '../../../../../../components/DangerousElement';
export const FinanceCheckoutLegalLayer = ({ buttonInfo, trackButtonClick, closeFocusLayer, }) => {
    const financeCheckoutLegalTranslations = {
        popoverHeading: useI18n({
            defaultMessage: '',
            id: `nemo.ui.sc.fs.checkout.popover.legalHeading`,
        }),
        popoverContent: useI18n({
            defaultMessage: '',
            id: `nemo.ui.sc.fs.checkout.popover.legalContent`,
        }),
        popoverCloseButton: useI18n({
            defaultMessage: '',
            id: `nemo.ui.sc.fs.checkout.popover.close`,
        }),
        popoverAriaCloseBtn: useI18n({
            defaultMessage: '',
            id: `nemo.ui.sc.fs.checkout.popover.popoverAriaCloseBtn`,
        }),
    };
    if (!financeCheckoutLegalTranslations.popoverContent) {
        return null;
    }
    return (React.createElement(FinanceCheckoutLegalLayerWrapper, { "data-testid": "Finance-checkout-legalLayer" },
        React.createElement(Headline, { tag: "h2", variant: {
                order: '4',
                weight: 'bold',
                type: 'headline',
            }, margin: [0, 0, SYS_SPACE_FIXED_300, 0] }, financeCheckoutLegalTranslations.popoverHeading),
        React.createElement(Text, { margin: [0, 0, SYS_SPACE_FIXED_300, 0], variant: {
                order: '1',
                style: 'normal',
                type: 'copy',
            } },
            React.createElement(DangerousElement, { as: "span", html: financeCheckoutLegalTranslations.popoverContent, sanitize: false })),
        React.createElement(FSPopoverCTASectionWrap, null,
            React.createElement(TextButton, { variant: "secondary", onClick: () => {
                    trackButtonClick(Object.assign(Object.assign({}, buttonInfo), { label: financeCheckoutLegalTranslations.popoverCloseButton, url: '' }), 'secondary', buttonInfo.trackingCode, 'cancel');
                    closeFocusLayer();
                }, "data-testid": `${buttonInfo.type}-close`, "aria-label": financeCheckoutLegalTranslations.popoverAriaCloseBtn }, financeCheckoutLegalTranslations.popoverCloseButton))));
};
const FinanceCheckoutLegalLayerWrapper = styled.div `
  padding: ${SYS_SPACE_FIXED_50} 0 ${SYS_SPACE_FIXED_50} 0;
  display: flex;
  flex-direction: column;
`;
const FSPopoverCTASectionWrap = styled.div `
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  gap: ${SYS_SPACE_FIXED_100};
  min-height: 55px;
  @media (max-width: 479px) {
    flex-direction: column;
    button {
      width: 100%;
    }
  }
`;
